export const DRAG_HANDLE_SELECTOR = '[data-editor-block-ctrl-drag-handle]';
export const DRAG_HANDLE_WIDTH = 12;
